import { render, staticRenderFns } from "./fleet-column-description-small.vue?vue&type=template&id=b70517fe&scoped=true&"
import script from "./fleet-column-description-small.vue?vue&type=script&lang=js&"
export * from "./fleet-column-description-small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70517fe",
  null
  
)

export default component.exports